import { useState, useContext, useEffect } from "react";
import { AppContext } from "../AppContext";
import { login, getEvents } from "../electronicRegisters/classeviva";
import useObjectState from "./useObjectState";


const useClasseviva = (offline, user) => {
    const { registerAccessToken, setRegisterAccessToken } = useContext(AppContext);

    const [registerEvents, setRegisterEvents, deleteRegisterEvent, updateRegisterEvents] = useObjectState(null);
    const [studentId, setStudentId] = useState(null); 

    useEffect(() => {
        (async () => {
            if (offline || !user)
                return;

            const registerUser = await login(user);
            setRegisterAccessToken(registerUser.token);
            setStudentId(registerUser.ident);
            setRegisterEvents(getEvents(registerUser.token, registerUser.ident));
        })();
    }, [offline, user]);

    return [studentId, setStudentId, registerEvents, updateRegisterEvents, deleteRegisterEvent];
};

export default useClasseviva;